export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            了解51动漫的故事与使命
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="space-y-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              <strong className="text-foreground-800">51动漫</strong>是一个专注于免费动漫在线观看的内容平台，
              致力于为动漫爱好者提供<strong className="text-foreground-800">日漫、韩漫、国漫</strong>全品类的高品质阅读体验。
              平台自上线以来，始终坚持以用户为中心，通过<strong className="text-foreground-800">下拉式连续阅读</strong>的创新交互，
              让追番变得像刷动态一样简单自然。
            </p>

            <p>
              我们深知每一部动漫作品背后都凝聚着创作者的心血与热爱。51动漫坚持<strong className="text-foreground-800">正版内容路线</strong>，
              与国内外多家版权方保持紧密合作，确保平台内容的合法性与品质。目前资源库总量已突破<strong className="text-foreground-800">20000部</strong>，
              且每日保持同步更新，让每一位动漫迷都不会错过最新话。
            </p>

            <p>
              在品类覆盖上，51动漫涵盖了热血冒险、恋爱校园、奇幻异世界、悬疑推理、搞笑日常、科幻巨制、古风国风等全题材，
              无论你是追新番的潮流党，还是补经典的怀旧派，都能在这里找到心仪的作品。
              移动端全面适配，打开浏览器即可畅享高清阅读，收藏进度多端同步。
            </p>

            <p>
              未来，51动漫将持续扩充内容库，优化阅读体验，并探索更多互动功能，
              努力成为动漫爱好者最值得信赖的<strong className="text-foreground-800">免费动漫平台</strong>。你的每一次点击与追更，
              都是我们不断进步的动力。
            </p>
          </div>

          {/* Stats row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10 pt-8 border-t border-background-200/70">
            {[
              { value: '20000+', label: '动漫资源' },
              { value: '300万+', label: '活跃用户' },
              { value: '每日更新', label: '同步连载' },
              { value: '5年', label: '运营时长' },
            ].map((stat, idx) => (
              <div key={idx} className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}